import { onOff } from '@iotv/iotv-v3-types'
import { FullReported } from '../../types'
import { Irrigator } from './Irrigator'
import { MasterValve } from '../MasterValve'

const sfToSensitivityMap: { [k: number]: number } = {
  6: -121,
  7: -124,
  8: -127,
  9: -130,
  10: -133,
  11: -136,
  12: -139,
}

export const convertToMarginLink = (sf?: number, snr?: number, rssi?: number): number | undefined => {
  if (sf !== undefined && snr !== undefined && rssi !== undefined) {
    let first = 10 * Math.log10(Math.pow(10, rssi / 10) - Math.pow(10, rssi / 10) / (1 + Math.pow(10, snr / 10)))
    let second = sfToSensitivityMap[sf] ?? 0
    return Math.max(Math.floor(first - second), 0)
  }
}

const log = false
/**
 * @function updateEntity is bound to Irrigator Class instance in constructor
 * @param payload
 */
export function updateEntity(this: Irrigator | MasterValve, payload: Partial<FullReported>): void {
  log && console.log('updateEntity called')
  console.log('payload', payload)
  const { battery, error, firmwareVersion, margin, moisture, octants, status, sysTime, temperature, meta, scheduleReport } = payload
  const { buttonTime, pulsesOn, pulsesOff, boostVoltage, rtcAdjustment } = payload

  const { deviceEui, customerDeviceId, sf, rssi, snr, gatewayEui, timestamp, currentTimestamp = Date.now() } = meta ?? {}

  this.deviceBatteryVoltage = battery ?? this.deviceBatteryVoltage // inherited
  this.error = error ?? this.error
  this.firmwareVersion = firmwareVersion ?? this.firmwareVersion
  this.margin = margin !== undefined ? margin : this.margin
  this.moisture = moisture !== undefined ? moisture : this.moisture
  this.octants = octants ?? this.octants
  this.status = status ?? this.status
  this.sysTime = sysTime ?? this.sysTime
  this.temperature = temperature ?? this.temperature
  this.config = scheduleReport?.config ?? this.config // config of sequential
  this.rollingPatternConfig = scheduleReport?.rollingPatternConfig ?? this.rollingPatternConfig

  this.buttonTime = buttonTime ?? this.buttonTime
  this.pulsesOn = pulsesOn ?? this.pulsesOn
  this.pulsesOff = pulsesOff ?? this.pulsesOff
  this.solenoidVoltage = boostVoltage ?? this.solenoidVoltage

  if (boostVoltage && deviceEui) {
    // if has boost voltage, update the solenoid voltage eui that reported it
    this.solenoidVoltageEUI = deviceEui
  }

  this.rtcAdjustment = rtcAdjustment ?? this.rtcAdjustment

  const { accelerometerActive, activePattern, downlinkAck, rebooted, sprinklerStatus } = status ?? {}
  let currentTime = currentTimestamp

  this.updated_at = currentTime
  this.timestamp = currentTime
  // if (sprinklerStatus) {
  if (this.isOperating && sprinklerStatus === onOff.OFF) {
    this.lastActive = currentTimestamp // in seconds
  }
  this.irrigating = sprinklerStatus === onOff.ON

  this.isOperating = sprinklerStatus !== undefined ? sprinklerStatus === onOff.ON : this.isOperating
  if (this.isOperating) {
    this.last_on = Date.now()
  }
  this.activePattern = activePattern !== undefined ? activePattern : this.activePattern

  if (meta) {
    const { deviceEui, customerDeviceId, sf, rssi, snr, gatewayEui } = meta

    const nowTime = Date.now()

    if (timestamp) {
      const compDiff = Math.abs(timestamp - nowTime) / 1000
      if (compDiff > 20) {
        currentTime = nowTime
      }
    }

    this.deviceEui = deviceEui ?? this.deviceEui
    this.customerDeviceId = customerDeviceId ?? this.customerDeviceId
    this.sf = sf ?? this.sf
    this.rssi = rssi ?? this.rssi
    this.snr = snr ?? this.snr
    this.gatewayEui = gatewayEui ?? this.gatewayEui

    this.linkMargin = convertToMarginLink(this.sf, this.snr, this.rssi) ?? this.linkMargin
  }
}
